var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext } from "react";
import { FilterContext } from "../../providers/FilterProvider";
import { DownloadableSection } from "../DownloadableSection/DownloadableSection";
import styles from "./DistributionBarSet.module.scss";
import BarChart from "../BarChart/BarChart";
import { DistributionSet, getWithBucketDescriptionTexts, } from "../DonutChart/DistributionSet";
import { Tab } from "../../common/cohortHelpers";
import { cohortSet } from "../../common/cohortConfiguration";
import { getColorDecider } from "../../common/action";
var ChartsFrame = function (_a) {
    var donut = _a.donut, bar = _a.bar, legendContent = _a.legendContent;
    return (_jsxs(_Fragment, { children: [legendContent && (_jsx("div", __assign({ className: styles.levelledLegendContainer }, { children: legendContent }))), _jsxs("div", __assign({ className: styles.chartContainer }, { children: [_jsx("div", __assign({ className: styles.piChartContainer }, { children: _jsxs(DownloadableSection, __assign({ filename: "donut-chart.png" }, { children: [_jsx("div", __assign({ className: styles.chartTitle }, { children: donut.title })), _jsx("div", __assign({ className: styles.donutChartInner }, { children: donut.content }))] })) })), _jsx("div", __assign({ className: styles.barChartContainer }, { children: _jsxs(DownloadableSection, __assign({ filename: "bar-chart.png" }, { children: [_jsx("div", __assign({ className: styles.chartTitle }, { children: bar.title })), bar.content] })) }))] }))] }));
};
export var DistributionBarSet = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var useChartData = _a.useChartData, reportId = _a.reportId, category = _a.category, skillGroup = _a.skillGroup, skillName = _a.skillName, barTitle = _a.barTitle, barChartProps = _a.barChartProps, donutTitle = _a.donutTitle;
    var configuration = (_b = cohortSet[category]) === null || _b === void 0 ? void 0 : _b[skillGroup];
    var getFilters = useContext(FilterContext).getFilters;
    var apiSkillGroup = (_c = configuration === null || configuration === void 0 ? void 0 : configuration.distributionSkillGroup) !== null && _c !== void 0 ? _c : skillGroup;
    var apiSkill = skillName !== null && skillName !== void 0 ? skillName : configuration === null || configuration === void 0 ? void 0 : configuration.distributionSkillName;
    var leaderScoresAssessment = useChartData({
        filters: getFilters(),
        reportId: reportId,
        skillGroup: apiSkillGroup,
        skill: apiSkill,
        category: category,
    });
    if (!configuration ||
        !leaderScoresAssessment.isSuccess ||
        !((_d = leaderScoresAssessment === null || leaderScoresAssessment === void 0 ? void 0 : leaderScoresAssessment.data) === null || _d === void 0 ? void 0 : _d.data)) {
        return (_jsx(ChartsFrame, { legendContent: (_f = (_e = cohortSet[category]) === null || _e === void 0 ? void 0 : _e[skillGroup]) === null || _f === void 0 ? void 0 : _f.legendContent, donut: {
                title: donutTitle,
                content: _jsx(_Fragment, {}),
            }, bar: {
                title: barTitle || "",
                content: _jsx(_Fragment, {}),
            } }));
    }
    var averageScoreBySkillGroup = (_h = (_g = leaderScoresAssessment.data) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.averageScoreBySkillGroup;
    var skillGroupData = (averageScoreBySkillGroup === null || averageScoreBySkillGroup === void 0 ? void 0 : averageScoreBySkillGroup[skillGroup]) ||
        Object.values(averageScoreBySkillGroup || {})[0];
    var averageScoreValues = (_j = skillGroupData === null || skillGroupData === void 0 ? void 0 : skillGroupData.avg_of_score) === null || _j === void 0 ? void 0 : _j.toFixed(1);
    var barChartData = {
        axisData: (skillGroupData === null || skillGroupData === void 0 ? void 0 : skillGroupData.scores) || [],
        averageScore: averageScoreValues || "0.0",
        targetScore: ((_k = skillGroupData === null || skillGroupData === void 0 ? void 0 : skillGroupData.targetScore) === null || _k === void 0 ? void 0 : _k.toFixed(1)) || "0.0",
        showTarget: category == Tab.CBI
            ? ((skillGroupData === null || skillGroupData === void 0 ? void 0 : skillGroupData.showTarget) || false) &&
                ((_m = (_l = getFilters()) === null || _l === void 0 ? void 0 : _l.project) === null || _m === void 0 ? void 0 : _m.length) === 1
            : false,
    };
    var donutData = Object.entries((skillGroupData === null || skillGroupData === void 0 ? void 0 : skillGroupData.score_levels) || {})
        .reduce(function (current, _a) {
        var key = _a[0], value = _a[1];
        current[Number(key)] = value;
        return current;
    }, [])
        .map(function (count, index) { return ({
        count: count,
        color: {
            background: configuration.colors[index % configuration.colors.length].color,
            border: configuration.colors[index % configuration.colors.length].border,
        },
    }); }) || [];
    var colorDecider = getColorDecider(configuration.colors);
    var getScoreDescriptionText = function (score) {
        var _a, _b;
        var description = colorDecider(score).description;
        return (_b = (_a = description === null || description === void 0 ? void 0 : description[skillGroup]) !== null && _a !== void 0 ? _a : description === null || description === void 0 ? void 0 : description[category]) !== null && _b !== void 0 ? _b : "";
    };
    return (_jsx(ChartsFrame, { legendContent: configuration === null || configuration === void 0 ? void 0 : configuration.legendContent, donut: {
            title: donutTitle,
            content: (_jsx(DistributionSet, { label: "Leaders", radius: 100, buckets: getWithBucketDescriptionTexts(donutData) })),
        }, bar: {
            title: barTitle || "",
            content: (_jsx(BarChart, __assign({ category: category, data: barChartData, title: "", calculateBarWidth: category == Tab.SavilleSwiftAptitude
                    ? function (allowed) { return allowed - 3; }
                    : null, getScoreDescriptionText: getScoreDescriptionText, colors: configuration.colors }, __assign(__assign({}, configuration.barChartProps), (barChartProps || {}))))),
        } }));
};
